import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string
  add?: string[]
  remove?: string[]
}

class SetRoomProductPublishApi extends Service {
  constructor(data: DataType) {
    super()
    this.name = 'SET_ROOM_PRODUCT_PUBLISH'

    this.config = {
      url: `/v1/room/pub-product`,
      method: 'POST',
      data,
    }
  }
}

export const setRoomProductPublish = (data: DataType) => getCallApiFunction(new SetRoomProductPublishApi(data))
